module.exports = I18n.locale === 'en' ? require('./menuItems.en') : require('./menuItems.ru')
